import script from "./AbstractTableCell.vue?vue&type=script&lang=js"
export * from "./AbstractTableCell.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__